import { UserInvestor } from './model/user-investor.model';
import { Injectable } from '@angular/core';
import { HandlerService } from '../comunicator-native/handler/handler';
import { UserSignupDataService } from './user-signup-data.service';
import { DomainOrigin } from './model/domain-origin';

@Injectable({
  providedIn: 'root'
})
export class UserSignupDataMobileService implements UserSignupDataService{

  constructor(private handlerService: HandlerService) {}

  public postUserSignup(userData: UserInvestor): Promise<any> {
      const relCaronte = 'user-signup';
  
      return this.handlerService.caronteCommunicator(relCaronte, userData, null, true)
          .then((data: any) => {
              if (data) {
                  return Promise.resolve(data);
              } else {
                  return Promise.reject(data);
              }
          })
          .catch((error) => {
              return Promise.reject(error);
          });
  }

  getOrigin(): DomainOrigin {
    return DomainOrigin.Registration;
  }
}

